const Strategy = [
  {
    name: "Cost (cheap, gets the job done)",
    // factorWeight: ["0.4", "0.0", "0.0", "0.0", "0.3", "0.0", "0.2", "0.1", "0.0", "0.0"],
    factorWeight: ["0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0"],
    topCriterias : ["c1","c5"]
  },
  {
    name: "Response (quick delivery, faster than competition)",
    // factorWeight: ["0.0", "0.0", "0.4", "0.0", "0.0","0.3", "0.2", "0.1", "0.0", "0.0"],
    factorWeight: ["0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0"],
    topCriterias : ["c3","c7"]
  },
  {
    name: "Differentiation (Unique, long-lasting, innovative)",
    // factorWeight: ["0.0", "0.4", "0.0", "0.0", "0.0", "0.2", "0.0", "0.0", "0.3", "0.1"],
    factorWeight: ["0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0"],
    topCriterias : ["c2","c6"]
  },
];
const initialFactorWeightingData= [
  {
    id : "c1",
    criteria: "The net <strong>price</strong> (including discounts and freight charges) offered by each vendor",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c2",
    criteria: "The ability of each vendor to meet <strong>quality</strong> specifications consistently",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c3",
    criteria: "The ability of each vendor to meet specified <strong>delivery schedules</strong>",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c4",
    criteria: "The <strong>financial position and credit rating</strong> of each vendor",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c5",
    criteria: "The <strong>production facilities and capacity</strong> of each vendor",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c6",
    criteria: "The <strong>technical capability</strong> (including research and development facilities) of each vendor",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c7",
    criteria: "The <strong>communication system</strong> (with information on progress data of orders) of each vendor",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c8",
    criteria: "The <strong>warranties and claims</strong> policies of each vendor",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c9",
    criteria: "<strong>Compliance</strong> or likelihood of compliance with your procedures (both bidding and operating) by each vendor",
    currFactorWeight: "",
    weightedScore:""
  },
  {
    id : "c10",
    criteria: "The <strong>performance history</strong> of each vendor",
    currFactorWeight: "",
    weightedScore:""
  },
];

const SupplierDetails = [
  {
    "supplierId":"supplier1",
    "supplierName": "Lilac Ink Solutions",
    "weeklyDelivery": 1200,
    "yearsInService": 1,
    "bidCost": "25.00",
    "numberOfUnits": ["1-2899", "2900-5899", "5900-23500"],
    "perUnitPrice": ["7.00", "6.50", "6.00"],
    "weightedScoreText": "Lilac Ink Solutions Total Weighted Score: ",
    "selectedRatingOptions" : [4,2,2,2,1,3,2,1,2,1],
    "weightedScore" : ["0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0"]
  },
  {
    "supplierId":"supplier2",
    "supplierName": "Universal Ink",
    "weeklyDelivery": 1100,
    "yearsInService": 11,
    "bidCost": "50.00",
    "numberOfUnits": ["1-2699", "2700-5499", "5500-22000"],
    "perUnitPrice": ["7.00", "6.50", "6.00"],
    "weightedScoreText": "Universal Ink Total Weighted Score: ",
    "selectedRatingOptions" : [4,1,2,4,5,4,2,4,3,4],
    "weightedScore" : ["0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0"]
  },
  {
    "supplierId":"supplier3",
    "supplierName": "Eco Ink",
    "weeklyDelivery": 1050,
    "yearsInService": 6,
    "bidCost": "200.00",
    "numberOfUnits": ["1-3099", "3100-3299", "6300-25000"],
    "perUnitPrice": ["8.00", "7.50", "7.00"],
    "weightedScoreText": "Eco Ink Total Weighted Score: ",
    "selectedRatingOptions" : [1,2,5,2,1,4,3,3,2,2],
    "weightedScore" : ["0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0"]
  },
  {
    "supplierId":"supplier4",
    "supplierName": "Mega Ink, Inc",
    "weeklyDelivery": 950,
    "yearsInService": 16,
    "bidCost": "100.00",
    "numberOfUnits": ["1-2199", "2200-4499", "4500-18000"],
    "perUnitPrice": ["7.00", "6.50", "6.00"],
    "weightedScoreText": "Mega Ink, Inc. Total Weighted Score: ",
    "selectedRatingOptions" : [5,1,1,1,4,2,3,2,2,1],
    "weightedScore" : ["0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0"]
  },
  {
    "supplierId":"supplier5",
    "supplierName": "Quality Matters Ink",
    "weeklyDelivery": 1000,
    "yearsInService": 10,
    "bidCost": "0.00",
    "numberOfUnits": ["1-2899", "2900-5799", "5800-23000"],
    "perUnitPrice": ["7.00", "6.50", "6.00"],
    "weightedScoreText": "Quality Matters Ink Total Weighted Score: ",
    // "selectedRatingOptions" : [1,5,null,2,2,3,3,2,4,3],
    "selectedRatingOptions" : [1,5,3,2,2,3,3,2,4,3],
    "weightedScore" : ["0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0", "0.0"]
  }
]


export { Strategy, initialFactorWeightingData, SupplierDetails };
